export const LocalStorageConst = Object.freeze({
  TOKEN: "token",
  CURRENT_PROSPECT_ID: "currentProspectId",
});
